(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-size-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('size-guide-tabs')) {
  customElements.define('size-guide-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      var root = this;
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));

      function selectTab(selectedTab) {
        tabs.forEach(function (tab) {
          var selected = tab === selectedTab;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          root.querySelector('#' + tab.getAttribute('aria-controls')).hidden = !selected;
        });
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          selectTab(tab);
        });

        tab.addEventListener('keydown', function (event) {
          var nextIndex;
          switch (event.key) {
            case 'ArrowRight': nextIndex = (index + 1) % tabs.length; break;
            case 'ArrowLeft': nextIndex = (index - 1 + tabs.length) % tabs.length; break;
            case 'Home': nextIndex = 0; break;
            case 'End': nextIndex = tabs.length - 1; break;
            default: return;
          }
          event.preventDefault();
          selectTab(tabs[nextIndex]);
          tabs[nextIndex].focus();
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  } catch(e) { console.error(e); }
})();
})();
